export default {
    name: "BaseHeader",
}
